// import { sysDataDictionaryWbObj } from '@/hooks/sysDataDictionaryWbObj'
export default {
    // name: sysDataDictionaryWbObj?.value?.WZMC?.dataContent,
    slogan: 'começar seu caminho para a riqueza',
    // copyright: 'Copyright © 2021 @:site.name',
};